module.exports = __webpack_public_path__ + "static/media/ic-menu-open.d1514ad2.svg";